import React from 'react';
import styles from 'assets/css/OverviewComponent.module.css';
import { statusMessageHelpers, STATUS_STATE } from 'utils/statusUtils';
import { IconCautionTriangle } from '@ace/react-icons';

export const defaultModuleState = { moduleBanner: '', moduleWrapperClass: styles['moduleDefaultState--border'], moduleBannerClass: '', hasBanner: false };

export const formatCardModuleState = (wrapperState, bannerState, bannerContent) => {
    let hasBanner = bannerContent && bannerContent.length;
    let includeCautionIcon = hasBanner && (bannerState === STATUS_STATE.WARN || bannerState === STATUS_STATE.ALERT);
    let moduleBanner = includeCautionIcon ? <><IconCautionTriangle fill={'#fff'} /><span>{bannerContent}</span></> : bannerContent;
    
    return {
        hasBanner,
        moduleBannerClass: statusMessageHelpers.getStatusStateBackgroundClass(bannerState),
        moduleWrapperClass: statusMessageHelpers.getStatusStateBorderClass(wrapperState) || styles['moduleDefaultState--border'],
        moduleBanner
    };
}


export function getOverviewCardModuleDisplayProps(props) {
    const { ModuleState: moduleState, CompletionDate, VoucherExpiration, ModuleLink, Locked, HasSMARTGoal, IsSMARTGoalEnabled } = props;

    return {
        showComplete: moduleState === OverviewModuleState.COMPLETE && CompletionDate,
        showVoucher: moduleState === OverviewModuleState.VOUCHER_EXPIRING && VoucherExpiration,
        showNotPassed: moduleState === OverviewModuleState.NOT_PASSED,
        showAudit: moduleState === OverviewModuleState.AUDIT_NEEDED,
        showLocked: Locked,
        showLink: ModuleLink,
        showSmartGoalInfo: HasSMARTGoal && !(moduleState === OverviewModuleState.COMPLETE || moduleState === OverviewModuleState.NOT_PASSED || moduleState === OverviewModuleState.AUDIT_NEEDED),
        showSmartGoalToolLink: IsSMARTGoalEnabled && !HasSMARTGoal && moduleState !== OverviewModuleState.COMPLETE
    }
}

export const OverviewModuleState = {
    LOCKED: "Locked",
    NOT_STARTED: "Not_Started",
    NOT_REDEEMED: "Not_Redeemed",
    //BEGIN_NOW: "Begin_Now",
    VOUCHER_EXPIRING: "Voucher_Expiring",
    BEHIND_SCHEDULE: "Behind_Schedule",
    IN_PROGRESS: "In_Progress",
    NOT_PASSED: "Not_Passed",
    AUDIT_NEEDED: "Audit_Needed",
    COMPLETE: "Complete"
};

export const CardModuleState = {
    LOCKED: 'Locked',
    UPGRADE_REQUIRED: 'Upgrade_Required',
    NOT_STARTED: 'Not_Started',
    IN_PROGRESS: 'In_Progress',
    COMPLETED: 'Completed',
    FAILED: 'Failed'
};